import {Injectable} from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";

import {environment} from "../../../../environments/environment";
import {Subject, Observable} from "rxjs";
import {Nivelacion} from "../../../_models/nivelacion";

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class NivelacionesService {

  private subject = new Subject<any>();


  constructor(private http: HttpClient) {
  }

  getNivelaciones() {
    return this.http.get<Nivelacion[]>(`${API_URL}/api/Nivelaciones`)
      /*.map(res => {
      return new Nivelacion(this.extractData(res));
  })*/;
  }

  getNivelacionesAlumno(idMes) {
    return this.http.get<Nivelacion[]>(`${API_URL}/api/Nivelaciones/mes/${idMes}`)
  }

  getNivelacionesHijo(hijoID: number | string, mesID: number | string = 0) {
    return this.http.get(`${API_URL}/api/Nivelaciones/alumno/${hijoID}/mes/${mesID}`);
  }

  getNivelacionesDirectivo(idPeriodo) {
    return this.http.get<any[]>(`${API_URL}/api/Nivelaciones/periodo/${idPeriodo}`);
  }

  getNivelacionesRol() {
    return this.http.get(`${API_URL}/api/Nivelaciones/rol`);
  }

  getNivelacionesDirCurso(idCurso, idPeriodo) {
    return this.http.get<any[]>(`${API_URL}/api/Nivelaciones/curso/${idCurso}/${idPeriodo}`);
  }

  getReporte(fecha) {
    return this.http.get<any[]>(`${API_URL}/api/Nivelaciones/reporte/${fecha}`);
  }

  setEstadoCitacionNivelacion(modelo) {
    return this.http.post<HttpResponse<any>>(`${API_URL}/api/Nivelaciones/citar`, modelo, {});
  }

  getReporteCursoPeriodo(idPeriodo: string | number = 0) {
    return this.http.get<any[]>(`${API_URL}/api/Nivelaciones/profesores/periodo/${idPeriodo}`);
  }

  getNivelacionesEspeciales(fecha) {
    return this.http.get(`${API_URL}/api/Nivelaciones/especial/fecha/${fecha}`);
  }

  getExcepcionesEspeciales() {
    return this.http.get(`${API_URL}/api/Nivelaciones/excepciones`);
  }

  getMateriasEspeciales() {
    return this.http.get(`${API_URL}/api/Nivelaciones/especial/me/materias`);
  }

  getAlumnosMateriaEspecial(id, fecha) {
    return this.http.get(`${API_URL}/api/Nivelaciones/especial/alumnos/materia/${id}/fecha/${fecha}`);
  }

  setNivelacionesEspeciales(model) {
    return this.http.post(`${API_URL}/api/Nivelaciones/especial/citar`, model);
  }

  getServiceObservable() {
    return this.subject.asObservable();
  }


  public extractData(res: any) {
    let body = res.hasOwnProperty('items') ? res.items : res;
    return body || {};
  }
}
